import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryCountsController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryCountsController.php
* @route '/api/contact-directory/counts'
*/
const GetDirectoryCountsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDirectoryCountsController.url(options),
    method: 'get',
})

GetDirectoryCountsController.definition = {
    methods: ["get","head"],
    url: '/api/contact-directory/counts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryCountsController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryCountsController.php
* @route '/api/contact-directory/counts'
*/
GetDirectoryCountsController.url = (options?: RouteQueryOptions) => {
    return GetDirectoryCountsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryCountsController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryCountsController.php
* @route '/api/contact-directory/counts'
*/
GetDirectoryCountsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDirectoryCountsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryCountsController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryCountsController.php
* @route '/api/contact-directory/counts'
*/
GetDirectoryCountsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDirectoryCountsController.url(options),
    method: 'head',
})

export default GetDirectoryCountsController